export default "__VITE_ASSET__BxNUFcph__"